import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-tool",
  "use": "svg_i-tool-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-tool\"><path d=\"M0 10h2V8H0v2zm0 4h2v-2H0v2zm2 4v-2H0a2 2 0 0 0 2 2zM0 6h2V4H0v2zm12 12h2v-2h-2v2zm4-18H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 12H6V2h10v10zm-8 6h2v-2H8v2zm-4 0h2v-2H4v2z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol